//import { WalletGoogleField }          from '../wallet-android/wallet-google-field.enum';
import { WalletAppleField }           from '../wallet-iphone/wallet-apple-field.enum';
import { WalletTemplateModel }        from '../../../common/wallet-template.model';
import { WalletTemplateDataSource,
         DataType, 
         WalletGoogleField}                   from '../../../common/wallet-template-enums';
import { MediaModel }                 from '../../../common/media.model';
import { isNullOrWhitespace, getDateFromString }         from '../../../common/functions';
import { SafeStyle,
         DomSanitizer }               from 'node_modules/@angular/platform-browser';
import { Globals }                    from '../../../common/globals';
import { GalleryService }             from '../../../shared/gallery.service';
import { isNullOrUndefined } from 'src/app/common/functions';
import { Honeycomb } from 'src/app/shared/honeycomb-api/honeycomb-api';

export class EvaluatedField {
    public label: string = null;
    public text: string = null;
}

export class WalletCommon {


    constructor(
        private globals: Globals,
        private sanitizer: DomSanitizer,
        private service: GalleryService
    ) {

    }

    public getFieldValue(fieldType: WalletGoogleField | WalletAppleField,
                          walletTemplate: WalletTemplateModel,
                          mediaModel: MediaModel): string {
        if (!walletTemplate) { return ''; }
        if (!fieldType) { 
          console.log('Undefined fieldType');
          return '';
        }

        let field = null;
        if (walletTemplate.target ===  Honeycomb.Common.Enums.WalletTemplateTarget.google) {
            field = walletTemplate.fields.find(f => f.googleField === fieldType);
        } else if (walletTemplate.target ===  Honeycomb.Common.Enums.WalletTemplateTarget.apple) {
            field = walletTemplate.fields.find(f => f.appleField === fieldType);
        }

        if (!field) {
          //console.log('Undefined value field: ' + fieldType.toString());
          return '';
        }

        return this.formatField(field, mediaModel);
      }

      private formatField(field: any, mediaModel: MediaModel) {
        let result = null;

        if (!!field.dataSource )

        if (!field) { return ''; }

        if (isNullOrUndefined(mediaModel)) { return ''; }

        if (field.dataSource === WalletTemplateDataSource.None) {
          result = !isNullOrWhitespace(field.defaultValueSourceField) ? field.defaultValueSourceField : field.sourceField;
        } else if (field.dataSource === WalletTemplateDataSource.Media) {
          field.sourceField = field.sourceField.charAt(0).toLocaleLowerCase() + field.sourceField.slice(1); // lowecase first letter
          result = mediaModel[field.sourceField];
        }
        if (result === null) {
          if (field.defaultValueDataSource === WalletTemplateDataSource.None) {
            result = field.defaultValueSourceField;
          } else if (field.dataSource === WalletTemplateDataSource.Media || !isNullOrWhitespace(field.defaultValueSourceField)) {
            field.defaultValueSourceField
              = field.defaultValueSourceField.charAt(0).toLocaleLowerCase() +
                field.defaultValueSourceField.slice(1); // lowecase first letter
            result = mediaModel[field.defaultValueSourceField];
          }
        }
        if (!isNullOrWhitespace(result)) {
          if (field.dataType === DataType.DateTime) {
            result = getDateFromString(result).toLocaleString();
          } else if (field.dataType === DataType.ShortDate) {
            result = getDateFromString(result).toLocaleDateString();
          }
        }
        return result;
      }

      public getFieldLabel(fieldType: WalletGoogleField | WalletAppleField,
                                  walletTemplate: WalletTemplateModel,
                                  mediaModel: MediaModel): string {
        if (!walletTemplate) { return null; }

        if (!fieldType) { 
          console.log('Undefined fieldType');
          return '';
        }

        if (walletTemplate.fields.filter(f => (
           (walletTemplate.target ===  Honeycomb.Common.Enums.WalletTemplateTarget.google && f.googleField === fieldType)
           ||
           (walletTemplate.target ===  Honeycomb.Common.Enums.WalletTemplateTarget.apple && f.appleField === fieldType)
          )).length > 1) {
          let singleFilter = walletTemplate.fields.find(f => f.googleField === fieldType);
          console.error('Multiple labels for '
            + (singleFilter.googleField ? 'Google' : 'Apple') + ' fieldType: ' + fieldType);
        }

        let field = walletTemplate.fields.find(f =>
          (walletTemplate.target ===  Honeycomb.Common.Enums.WalletTemplateTarget.google && f.googleField === fieldType)
          ||
          (walletTemplate.target ===  Honeycomb.Common.Enums.WalletTemplateTarget.apple && f.appleField === fieldType));

        if (!field) {
          //console.log('Undefined label field: ' + fieldType.toString());
          return '';
        }
        let result = null;
        if (field.dataSource === WalletTemplateDataSource.None) {
          result = field.label;
        } else if (field.dataSource === WalletTemplateDataSource.Media) {
          field.label = field.label.charAt(0).toLocaleLowerCase() + field.label.slice(1); // lowecase first letter
          result = mediaModel[field.label];
        }
        if (result === null) {
          if (field.defaultValueLabelDataSource === WalletTemplateDataSource.None) {
            result = field.defaultValueLabel;
          } else if (field.defaultValueLabelDataSource === WalletTemplateDataSource.Media) {
            field.defaultValueLabel
              = field.defaultValueLabel.charAt(0).toLocaleLowerCase() + field.defaultValueLabel.slice(1); // lowecase first letter
            result = mediaModel[field.defaultValueLabel];
          }
        }
        return result;
      }

      public getFields(
            fieldType: WalletGoogleField | WalletAppleField,
            walletTemplate: WalletTemplateModel,
            mediaModel: MediaModel
      ): Array<EvaluatedField> {

        let fields: Array<EvaluatedField> = [];

        if (!fieldType) { 
          console.log('Undefined fieldType');
          return [];
        }


        if (!walletTemplate) { return []; }
        let templateFields = walletTemplate.fields
                                .filter(f =>  (walletTemplate.target ===  Honeycomb.Common.Enums.WalletTemplateTarget.google && f.googleField === fieldType)
                                ||
                                (walletTemplate.target ===  Honeycomb.Common.Enums.WalletTemplateTarget.apple && f.appleField === fieldType))
                                .sort((a, b) => a.fieldOrder - b.fieldOrder);

        for (const temField of templateFields) {
            let newEvalField = new EvaluatedField();

            /* Label */
            if (temField.labelDataSource === WalletTemplateDataSource.None) {
              newEvalField.label = temField.label;
            } else if (temField.labelDataSource === WalletTemplateDataSource.Media) {
              temField.label = temField.label.charAt(0).toLocaleLowerCase() + temField.label.slice(1); // lowecase first letter
              newEvalField.label = mediaModel[temField.label];
            } else if (temField.labelDataSource === WalletTemplateDataSource.VoucherAttributes) {
              newEvalField.label = temField.defaultValueLabel; // lowecase first letter
            }
            if (newEvalField.label === null) {
              if (temField.defaultValueLabelDataSource === WalletTemplateDataSource.None) {
                newEvalField.label = temField.label;
              } else if (temField.defaultValueLabelDataSource === WalletTemplateDataSource.Media) {
                temField.defaultValueLabel
                  = temField.defaultValueLabel.charAt(0).toLocaleLowerCase() + temField.defaultValueLabel.slice(1); // lowecase first letter
                  newEvalField.label = mediaModel[temField.defaultValueLabel];
              }
              if (isNullOrWhitespace(newEvalField.label) && !isNullOrWhitespace(temField.label)) {
                newEvalField.label = temField.label;
              }
            }

            /* Text */
            newEvalField.text = this.formatField(temField, mediaModel);

            fields.push(newEvalField);
        }

        return fields;
      }

      public getImage(imageUid: string, size = 512): SafeStyle {
        let imgUid = imageUid || this.globals.getNoImageUID;

        let url = this.sanitizer.bypassSecurityTrustStyle('url(\'' +
          this.globals.GetUrlPrefix() +
          '/api/gallery/ThumbByID/' + size + '/' +
          imgUid +
          // '/' + 'file.png' +
          '?TenantID=' +
          this.globals.getTenantID() +
          '\')');

        return url;
      }

      public async getImageAsync(imageUid: string, size = 512): Promise<SafeStyle> {
        let imgUid = imageUid || this.globals.getNoImageUID;

        let metadata = imgUid !== this.globals.getNoImageUID ?
                          await this.service.getMetadata(imgUid).toPromise() :
                          { fileName: 'noImage.png' };

        let url = this.sanitizer.bypassSecurityTrustStyle('url(\'' +
          this.globals.GetUrlPrefix() +
          '/api/gallery/ThumbByID/' + size + '/' +
          imgUid +
          '/' + metadata.fileName +
          '?TenantID=' +
          this.globals.getTenantID() +
          '\')');

        return await Promise.resolve(url);
      }
}


